'use client';

import * as React from 'react';
import { ToastContainer, Icons, type IconProps } from 'react-toastify';
import { ToastIcon } from '@/components/shared/toast/ToastIcon';
import '@/components/shared/toast/toast.css';

interface IToastProviderProps {
  children: React.ReactNode;
}

/** react-toastify's statuses on the app's one toast mark; plain toasts carry none. */
const toastifyIcon = ({ type, isLoading }: IconProps) => {
  if (isLoading) return Icons.spinner();
  if (type === 'success' || type === 'error' || type === 'warning' || type === 'info') return <ToastIcon tone={type} />;
  return false;
};

const ToastProvider: React.FunctionComponent<IToastProviderProps> = ({ children }) => {
  return (
    <>
      {children}
      <ToastContainer
        className='mb-toast'
        position='bottom-right'
        icon={toastifyIcon}
        hideProgressBar
        autoClose={5000}
        closeOnClick
        draggable
        pauseOnHover={false}
        theme='light'
      />
    </>
  );
};

export default ToastProvider;
